import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import map from 'ramda/src/map'
import { GET_CREATORS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import {
	searchPlatformCreatorsKey,
} from 'root/src/shared/constants/keys'

export default async ({ query, platform }) => {
	const payload = {
		value: {
			query,
			platform,
		},
		section: searchPlatformCreatorsKey,
	}

	const { body } = await invokeApiRequest(GET_CREATORS, payload, {}, true)

	return map(({ image, displayName, mnemonicId, platformId }) => (
		{
			label: displayName,
			image,
			id: platformId,
			value: mnemonicId,
			platform,
		}
	), body)
}
